// extracted by mini-css-extract-plugin
export var columnList = "_cx-0";